import PropTypes from 'prop-types';
import { FaCheck } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import cleanseAmenities from '../../../../../helpers/cleanseAmenities';

const Amenities = ({ hotelAmenities, roomAmenities, headingClassName }) => {
  const { travelAgency } = useSelector((store) => store.user);

  const doCleanseAmenities = travelAgency && travelAgency.settings
  && travelAgency.settings.cleanseAmenities;
  const amenitiesFilteredList = doCleanseAmenities
    ? cleanseAmenities(hotelAmenities) : hotelAmenities;

  return (
    <>
      <div className={headingClassName}>
        {(roomAmenities || []).length > 0 ? 'Room amenities' : 'All amenities'}
      </div>
      <div className="grid md:grid-cols-3">
        {(amenitiesFilteredList || roomAmenities).length
      && (amenitiesFilteredList || roomAmenities).map((item) => (
        <div key={item} className="flex place-items-center">
          <FaCheck className="text-green-200 mr-2" />
          {item}
        </div>
      ))}
      </div>
    </>
  );
};
Amenities.propTypes = {
  hotelAmenities: PropTypes.arrayOf(PropTypes.string),
  roomAmenities: PropTypes.arrayOf(PropTypes.string),
  headingClassName: PropTypes.string,
};

Amenities.defaultProps = {
  hotelAmenities: [],
  roomAmenities: [],
  headingClassName: 'font-bold',
};
export default Amenities;
